import fetch from 'cross-fetch';
import urlJoin from 'url-join'
import Cookies from 'universal-cookie'
import { BASE_URL, BASE_API_URL, TRANSLATE_DEFAULT_LANGUAGE } from 'src/common/razzle-platform-translate/configs'
import { createModel, Models } from '@rematch/core'


export interface TransactionRootModel extends Models<TransactionRootModel> {
    translationModel: typeof translationModel
}

export type ILocale = 'fr' | 'en' | 'de' | 'gr' | 'jp' | 'pt' | 'ru' | 'es' | 'sv' | 'tr'
export type ITranslationData = { [key: string]: string }

export interface ITransltionState {
    locale: ILocale
    translations: ITranslationData | null
}

const defaultState: ITransltionState = {
    locale: TRANSLATE_DEFAULT_LANGUAGE as ILocale,
    translations: null,
}

export const translationModel = createModel<TransactionRootModel>()({
    effects: (dispatch) => ({
        // async loadLocale__(): Promise<void> {
        //     const cookies = new Cookies()
        //     const locale: ILocale = (cookies.get('pll_language') || TRANSLATE_DEFAULT_LANGUAGE) as ILocale
        //     const response = await axios.get(`${STATIC_PATH}/static/locales/${locale}.json`)
        //     dispatch.translationModel.setLocale({ locale, translations: response.data })
        // },
        async loadLocale(locale: ILocale): Promise<void> {
            try {

                const response = await fetch(urlJoin(BASE_API_URL, `translations/razzle/${locale}`))
                dispatch.translationModel.setLocale({ locale, translations: await response.json() })                
            } catch (error) {
                console.log('errrrorrrrrrrrr0', error)
            }

        },
        async syncLocaleWithBackend(): Promise<void> {
            await fetch(`${BASE_URL}language`)
        },
    }),
    reducers: {
        setLocale(state: ITransltionState, payload: ITransltionState) {
            return {
                ...state,
                ...payload,
            }
        },
    },
    state: defaultState,
})
